import loadable from '../../../utilities/loadable'

export const FavoriteButton = loadable(() => import('./FavoriteButton'))
export const GpiFavoriteButton = loadable(() => import('./GpiFavoriteButton'))
